import { Component, OnInit, OnDestroy } from '@angular/core';
import { LeaderboardPublicService } from '../services/leaderboard-public.service';

@Component({
  selector: 'app-leaderboard-embed',
  templateUrl: './leaderboard-embed.component.html',
  styleUrls: ['./leaderboard-embed.component.scss']
})
export class LeaderboardEmbedComponent implements OnInit, OnDestroy {

  loading = true;
  error = false;
  errorMessage = '';

  groupName = '';
  schoolName = '';
  primaryColor = '#3366FF';
  secondaryColor = '#6699FF';
  logoUrl = '';
  leaderboards: any[] = [];

  currentIndex = 0;

  private refreshInterval: any;
  private cycleInterval: any;
  private token = '';

  constructor(private leaderboardService: LeaderboardPublicService) {}

  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);
    this.token = params.get('token') || '';

    if (!this.token) {
      this.loading = false;
      this.error = true;
      this.errorMessage = 'This leaderboard is no longer available.';
      return;
    }

    this.fetchData();

    // Auto-refresh every 30 seconds
    this.refreshInterval = setInterval(() => {
      this.fetchData(true);
    }, 30000);

    // Auto-cycle boards every 10 seconds
    this.cycleInterval = setInterval(() => {
      if (this.leaderboards.length > 1) {
        this.currentIndex = (this.currentIndex + 1) % this.leaderboards.length;
      }
    }, 10000);
  }

  ngOnDestroy(): void {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
    if (this.cycleInterval) {
      clearInterval(this.cycleInterval);
    }
  }

  get currentBoard(): any {
    return this.leaderboards[this.currentIndex] || null;
  }

  goToBoard(index: number): void {
    this.currentIndex = index;
    this.resetCycleTimer();
  }

  goPrev(): void {
    this.currentIndex = (this.currentIndex - 1 + this.leaderboards.length) % this.leaderboards.length;
    this.resetCycleTimer();
  }

  goNext(): void {
    this.currentIndex = (this.currentIndex + 1) % this.leaderboards.length;
    this.resetCycleTimer();
  }

  private resetCycleTimer(): void {
    if (this.cycleInterval) {
      clearInterval(this.cycleInterval);
      this.cycleInterval = setInterval(() => {
        if (this.leaderboards.length > 1) {
          this.currentIndex = (this.currentIndex + 1) % this.leaderboards.length;
        }
      }, 10000);
    }
  }

  formatScore(score: number, decimalPlaces?: number): string {
    if (score == null) return '-';
    const dp = decimalPlaces != null ? decimalPlaces : 1;
    if (dp === 0) return Math.round(score).toString();
    return score % 1 === 0 ? score.toString() : score.toFixed(dp);
  }

  getRankClass(rank: number): string {
    if (rank === 1) return 'rank-gold';
    if (rank === 2) return 'rank-silver';
    if (rank === 3) return 'rank-bronze';
    return '';
  }

  private fetchData(silent = false): void {
    if (!silent) {
      this.loading = true;
    }

    this.leaderboardService.getPublicGroup(this.token).subscribe(
      (data: any) => {
        this.groupName = data.Name;
        this.schoolName = data.SchoolName || '';
        this.primaryColor = data.PrimaryColor || '#3366FF';
        this.secondaryColor = data.SecondaryColor || '#6699FF';
        this.logoUrl = data.LogoUrl || '';
        this.leaderboards = data.Leaderboards || [];

        // Ensure currentIndex stays in bounds after refresh
        if (this.currentIndex >= this.leaderboards.length) {
          this.currentIndex = 0;
        }

        this.loading = false;
        this.error = false;
      },
      () => {
        if (!silent) {
          this.loading = false;
          this.error = true;
          this.errorMessage = 'This leaderboard is no longer available.';
        }
      }
    );
  }
}
